// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"c0ad168d","213":"c0ad168d"}[chunkId] + ".chunk.css";
};